import { useId } from 'react';
import { NavLink } from 'react-router';
import { Tooltip } from 'react-tooltip';

import { useTutorWallet } from 'hooks/useTutorWallet';
import { formatRubDisplay } from 'utils/formatMoneyRu';
import walletIcon from 'assets/icons/Header/wallet.svg';

import styles from './HeaderWalletBalance.module.scss';

export const HeaderWalletBalance = () => {
  const tooltipId = useId();
  const { data: wallet } = useTutorWallet();
  const available = wallet?.available_rub ?? '0.00';
  const { primary, full, isCompact } = formatRubDisplay(available);

  return (
    <NavLink
      to='/teacher/wallet'
      className={({ isActive }) =>
        `${styles.link} ${isActive ? styles['link--active'] : ''}`.trim()
      }
      aria-label={`Баланс: ${full}`}
      data-tooltip-id={tooltipId}
      data-tooltip-content={isCompact ? full : undefined}
    >
      <span className={styles.iconWrap}>
        <img src={walletIcon} alt='' width={30} height={26} />
      </span>
      <span className={styles.amount}>{primary}</span>
      {isCompact && (
        <Tooltip id={tooltipId} className={styles.tooltip} place='bottom' />
      )}
    </NavLink>
  );
};
